export default "__VITE_ASSET__ZjSX$KdQ__"